export default __webpack_public_path__ + "static/media/clientDummy.b1a84665.png";